import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { Textarea } from '../ui/Textarea';
import { Input } from '../ui/Input';
import { RadioGroup } from '../ui/RadioGroup';
import { MascotPanel } from '../ui/MascotPanel';
export function Step8Goals() {
  const {
    data,
    updateData
  } = useIntake();
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-561">
      <MascotPanel message="Een mooie website is leuk, maar hij moet vooral resultaat opleveren. Wat is het belangrijkste doel van uw nieuwe website?" data-id="element-562" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 space-y-8" data-id="element-563">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-564">Website Doelen</h2>

        <div data-id="element-565">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-566">
            Wat is het primaire doel van de website?
          </label>
          <RadioGroup columns={1} value={data.mainGoal} onChange={val => updateData({
          mainGoal: val
        })} options={[{
          value: 'leads',
          label: 'Leads genereren (offerte aanvragen, contactopnames)'
        }, {
          value: 'sales',
          label: 'Directe verkoop (webshop, online boekingen)'
        }, {
          value: 'info',
          label: 'Informatievoorziening (online visitekaartje, portfolio)'
        }, {
          value: 'support',
          label: 'Klantenservice (FAQ, handleidingen, portaal)'
        }, {
          value: 'employer',
          label: 'Personeel werven (vacatures, employer branding)'
        }, {
          value: 'other',
          label: 'Anders...'
        }]} data-id="element-567" />

          <AnimatePresence data-id="element-568">
            {data.mainGoal === 'other' && <motion.div initial={{
            opacity: 0,
            height: 0
          }} animate={{
            opacity: 1,
            height: 'auto'
          }} exit={{
            opacity: 0,
            height: 0
          }} className="mt-4 overflow-hidden" data-id="element-569">
                <Input placeholder="Vul hier uw primaire doel in..." value={data.mainGoalOther} onChange={e => updateData({
              mainGoalOther: e.target.value
            })} data-id="element-570" />
              </motion.div>}
          </AnimatePresence>
        </div>

        <Textarea label="Wat is de belangrijkste actie die een bezoeker moet ondernemen?" infoTooltip="De Call-To-Action (CTA). Bijv: 'Een afspraak inplannen', 'Een product kopen', of 'Bellen'." placeholder="Bijv. Het invullen van het contactformulier..." value={data.visitorAction} onChange={e => updateData({
        visitorAction: e.target.value
      })} data-id="element-571" />

        <Textarea label="Wie is uw ideale doelgroep?" placeholder="Beschrijf uw ideale klant (leeftijd, branche, problemen die ze ervaren)..." value={data.targetAudience} onChange={e => updateData({
        targetAudience: e.target.value
      })} data-id="element-572" />

        <div className="pt-6 border-t border-gray-100 space-y-8" data-id="element-573">
          <Textarea label="Welke websites vindt u mooi of inspirerend? (URL's)" infoTooltip="Referentiewebsites geven ons een concreet beeld van uw smaak. Het hoeven geen websites uit uw branche te zijn." placeholder="Plak hier links naar websites die u aanspreken qua design, structuur of sfeer..." value={data.inspirationWebsites} onChange={e => updateData({
          inspirationWebsites: e.target.value
        })} data-id="element-574" />

          <Textarea label="Wat moet een bezoeker voelen/denken bij het zien van uw website?" placeholder="Bijv. Dit bedrijf is betrouwbaar en professioneel, hier wil ik klant worden..." value={data.desiredImpression} onChange={e => updateData({
          desiredImpression: e.target.value
        })} data-id="element-575" />
        </div>
      </div>
    </motion.div>;
}